import { render, staticRenderFns } from "./WhatIRead.vue?vue&type=template&id=53689c04&"
import script from "./WhatIRead.vue?vue&type=script&lang=js&"
export * from "./WhatIRead.vue?vue&type=script&lang=js&"
import style0 from "./WhatIRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WhatIRead.vue"
export default component.exports